import { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { lenisRef } from "@/lib/scroll";
import ErrorBoundary from "@/components/ErrorBoundary";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Collections from "@/components/Collections";
import Products from "@/components/Products";
import Corporate from "@/components/Corporate";
import Craft from "@/components/Craft";
import About from "@/components/About";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";

function Site() {
  const [filter, setFilter] = useState("All");

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      lenisRef.current = null;
    };
  }, []);

  useEffect(() => {
    const onFilter = (e) => {
      setFilter(e.detail);
      setTimeout(() => {
        const el = document.querySelector("#products");
        if (el && lenisRef.current) lenisRef.current.scrollTo(el, { offset: -72, duration: 1.2 });
      }, 60);
    };
    window.addEventListener("set-product-filter", onFilter);
    return () => window.removeEventListener("set-product-filter", onFilter);
  }, []);

  return (
    <div className="bg-ivory text-charcoal font-sans antialiased selection:bg-terracotta">
      <div className="grain" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Collections
          onSelectFilter={(c) => {
            setFilter(c);
            const el = document.querySelector("#products");
            if (el && lenisRef.current) lenisRef.current.scrollTo(el, { offset: -72, duration: 1.2 });
          }}
        />
        <Products filter={filter} onFilterChange={setFilter} />
        <Corporate />
        <Craft />
        <About />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFloat />
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <Site />
      </ErrorBoundary>
    </BrowserRouter>
  );
}
